import { MyIntakeModelConfiguration } from './configs/my_intake_model_configuration';
import { MajorTileFunction } from './functions/major_tile_fn';
import { MajorBuilderServant } from './servants/major_builder_servant';
import { MajorDataToggleService } from './services/major_data_toggle_service';
import { MajorSearchService } from './services/major_search_service';
import { MajorService } from './services/major_service';
import { ProgramSortEnum } from './types/program_sort_enum';

angular
  .module('major-explorer-data', [])
  .service('majorDataToggleService', MajorDataToggleService)
  .service('ngMajorSearchService', MajorSearchService)
  .service('ngMajorService', MajorService)
  .service('ngMajorBuilderServant', MajorBuilderServant)
  .service('majorTileFn', MajorTileFunction)
  .factory('programSortEnum', ProgramSortEnum)
  .config(MyIntakeModelConfiguration);

// COMMANDS
import './commands/delete_metaranking_command';
import './commands/get_reminder_about_majors_command';
import './commands/load_developmental_courses_command';
import './commands/load_favorite_programs_command';
import './commands/load_listselection_command';
import './commands/load_major_detail_command';
import './commands/load_major_explorer_intake_command';
import './commands/load_metaranking_command';
import './commands/load_program_programslot_command';
import './commands/load_programs_command';
import './commands/load_related_careers_command';
import './commands/load_search_programs_command';
import './commands/load_student_current_major_command';
import './commands/save_choice_question_command';
import './commands/save_item_command';
import './commands/save_list_selection_activity_command';
import './commands/save_list_selection_subject_command';
import './commands/save_major_command';
import './commands/save_metaranking_command';
import './commands/save_reminder_about_majors_command';
import './commands/unsave_major_command';

// TYPES
import './types/hiring_trend_enum';
import './types/major_explorer_user_activity_name_enum';
import './types/programs_presenter_view_state';

// FUNCTIONS
import './functions/choice_question_fn';
import './functions/list_selection_fn';
import './functions/major_explorer_user_activity_fn';
import './functions/major_tile_fn';
import './functions/metaranking_fn';
import './functions/programs_fn';

// MODELS
require('./models/my_intake_model');
import './models/major_program_model';
import './models/my_intake_history_model';

// BUILDERS
import './builders/major_course_map_course_builder';
import './builders/major_course_map_program_builder';
import './builders/major_credential_builder';
import './builders/major_dev_course_builder';
import './builders/major_listselection_builder';
import './builders/major_metaranking_builder';
import './builders/major_programs_builder';

// DATSOURCE
import './datasources/major_course_map_course_datasource';
import './datasources/major_course_map_program_datasource';
import './datasources/major_credential_datasource';
import './datasources/major_current_majors_datasource';
import './datasources/major_dev_courses_datasource';
import './datasources/major_program_datasource';

// QUERIES
import './queries/major_course_map_query';
import './queries/major_credential_query';
import './queries/major_current_majors_query';
import './queries/major_dev_courses_query';
import './queries/major_programs_query';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/major_explorer_data_module.ts